// extracted by mini-css-extract-plugin
export default {"root":"Loader_root__UXdjP","svg":"Loader_svg__w1aN7","rotate":"Loader_rotate__f-R0u","circle":"Loader_circle__BjCdR","dash":"Loader_dash__8lEzk"};